export const EU_COUNTRIES_CODES = [
    //codes
    'AT', // 'Austria'
    'BE', // 'Belgium'
    'BG', // 'Bulgaria'
    'HR', // 'Croatia'
    'CY', // 'Republic of Cyprus'
    'CZ', // 'Czech Republic'
    'DK', // 'Denmark'
    'EE', // 'Estonia'
    'FI', // 'Finland'
    'FR', // 'France'
    'DE', // 'Germany'
    'GR', // 'Greece'
    'HU', // 'Hungary'
    'IE', // 'Ireland'
    'IT', // 'Italy'
    'LV', // 'Latvia'
    'LT', // 'Lithuania'
    'LU', // 'Luxembourg'
    'MT', // 'Malta'
    'NL', // 'Netherlands'
    'PL', // 'Poland'
    'PT', // 'Portugal'
    'RO', // 'Romania'
    'SK', // 'Slovakia'
    'SI', // 'Slovenia'
    'ES', // 'Spain'
    'SE', // 'Sweden'
];

export const EU_TLDS = [
    'ie', // 'Ireland'
    'fr', // 'France'
    'es', // 'Spain'
    'it', // 'Italy'
    'pt', // 'Portugal'
    'de', // 'Germany'
    'nl', // 'Netherlands'
    'at', // 'Austria'
    'be', // 'Belgium'
    'dk', // 'Denmark'
    'fi', // 'Finland'
    'se', // 'Sweden'
];

export const EU_COUNTRIES_NAMES = [
    'Austria',
    'Belgium',
    'Bulgaria',
    'Croatia',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Greece',
    'Hungary',
    'Ireland',
    'Italy',
    'Latvia',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Netherlands',
    'Poland',
    'Portugal',
    'Romania',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Sweden',
];

// Add UK-specific constants
export const UK_COUNTRIES_CODES = [
    'GB', // Great Britain / United Kingdom
    'UK', // United Kingdom
];

export const UK_TLDS = ['co.uk'];

export const UK_COUNTRIES_NAMES = ['United Kingdom'];

export const MULTIPART_TLDS = ['co.uk'];

// -----------------------------------------------------------------------------
// Scalable Regulation helper
// -----------------------------------------------------------------------------

interface RegulationConfig {
    label: string; // e.g. "EU DSA", "UK OSA"
    eventLocation: readonly string[];
    tlds: readonly string[];
    ipLocation: readonly string[];
}

export const REGULATIONS: RegulationConfig[] = [
    {
        label: 'EU DSA',
        eventLocation: EU_COUNTRIES_CODES,
        tlds: EU_TLDS,
        ipLocation: EU_COUNTRIES_NAMES,
    },
    {
        label: 'UK OSA',
        eventLocation: UK_COUNTRIES_CODES,
        tlds: UK_TLDS,
        ipLocation: UK_COUNTRIES_NAMES,
    },
];
